import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorService } from '../error/error.service';
import { AuthService } from '../auth/auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private errorService: ErrorService,
    private auth: AuthService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Token ${this.auth.getToken()}`
        }
      });
    } else {
      this.auth.logout(true);
    }

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      // success
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        this.spinner.hide();
        if (err.status === 500) {
          this.showError(
            'Internal service error',
            'Error -- 500'
          );
        } else {
          this.handleError(err);
        }
      }

    })
    );
  }

  public handleError(errors) {
    const e = Object.assign(
      {},
      ...(function _flatten(o) {
        return [].concat(
          ...Object.keys(o).map((k) => {
            if (Array.isArray(o[k])) {
              return { [k]: `${k}: ${o[k].join(', ')}` };
            } else if (typeof o[k] === 'object') {
              return _flatten(o[k]);
            } else {
              return { [k]: `${k}: ${o[k]}` };
            }
          })
        );
      })(errors.error)
    );

    this.showError(Object.values(e).join('\n'), errors.statusText, {
      enableHtml: true,
    });
  }

  showError(msg: string, status: string, args = null) {
    this.toastr.error(msg, status, args);
  }

}
